"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountButtonMenu = void 0;
var commonBlockOptions_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonBlockOptions");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var ColorUtils_1 = require("Common/Utils/ColorUtils/ColorUtils");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var React = __importStar(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var c = (0, BemBuilder_1.default)("accept-button-menu");
var ButtonMenu = (function (_super) {
    __extends(ButtonMenu, _super);
    function ButtonMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.handleButtonColorChange = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var acceptButtonStyle = __assign({}, blockStyleStore.model.acceptButton);
            acceptButtonStyle.color.abs = color.value;
            acceptButtonStyle.color.themeIndex = color.themeIndex;
            blockStyleStore.setStylePropsByKey("acceptButton", acceptButtonStyle);
            _this.props.telemetry.trackOnly("Block Styles Contextual Changed", {
                block_styles_contextual_accept_button_color: (0, ColorUtils_1.getTelemetryColor)(color),
            }, {
                blockIntercom: true,
            });
        };
        _this.handleAlignmentChange = function (alignment) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var acceptButtonStyle = __assign({}, blockStyleStore.model.acceptButton);
            acceptButtonStyle.alignment = alignment;
            blockStyleStore.setStylePropsByKey("acceptButton", acceptButtonStyle);
        };
        var getAcceptLabel = props.getAcceptLabel;
        _this.acceptLabel = getAcceptLabel();
        return _this;
    }
    ButtonMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, brandStore = _a.brandStore, blockStyleStore = _a.blockStore.blockStyleStore;
        var acceptButton = blockStyleStore.model.acceptButton;
        return (React.createElement("div", { className: c() },
            React.createElement(kaleidoscope_1.Layer, { offset: 890 }, function () { return (React.createElement(kaleidoscope_1.Popover, { autoStack: true, size: kaleidoscope_1.PopoverSize.Small, position: kaleidoscope_1.PopoverPosition.Right, theme: kaleidoscope_1.PopoverTheme.Light, onClickStopPropagation: true, button: function (buttonProps) { return (React.createElement(kaleidoscope_1.Tooltip, { content: "Button options" },
                    React.createElement(kaleidoscope_1.IconButton, __assign({ icon: React.createElement(icons_1.Edit, null), size: kaleidoscope_1.ButtonSize.Medium, type: kaleidoscope_1.ButtonType.Secondary, isRound: true, className: c("button") }, buttonProps)))); } },
                React.createElement("div", { className: c("content") },
                    React.createElement(kaleidoscope_1.TextInput, { label: "Button Text", value: _this.acceptLabel, onChange: function (newLabel) {
                            _this.props.setAcceptLabel(newLabel);
                            _this.acceptLabel = newLabel;
                        } }),
                    React.createElement("div", { className: c("control-title") }, "Button Color"),
                    React.createElement(ColorPalette_1.default, { onColorChange: _this.handleButtonColorChange, presetColors: brandStore.colorsWithThemeIndex, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(acceptButton.color), brandStore.colorsWithThemeIndex), theme: "light", type: "content" }),
                    React.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Light, label: "Alignment", size: kaleidoscope_1.SegmentedControlSize.Medium, options: commonBlockOptions_1.alignmentOptions, selectedValue: acceptButton.alignment, onClickHandler: _this.handleAlignmentChange })))); })));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], ButtonMenu.prototype, "acceptLabel", void 0);
    ButtonMenu = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ButtonMenu);
    return ButtonMenu;
}(React.Component));
exports.default = ButtonMenu;
var mountButtonMenu = function (brandStore, blockStore, telemetry, mountReactComponent, getAcceptLabel, setAcceptLabel) {
    return mountReactComponent(React.createElement(ButtonMenu, { brandStore: brandStore, blockStore: blockStore, telemetry: telemetry, getAcceptLabel: getAcceptLabel, setAcceptLabel: setAcceptLabel }));
};
exports.mountButtonMenu = mountButtonMenu;
